import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import {OEMediaType} from '../../../../react-oe/oe-types';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import {oeUniqueIdGen} from '../../../../lib/tools/oe-unique-id-gen';
import OEIcon from '../../../elements/oe-icon';
import {OEIconButton} from '../../../elements/controls/oe-button';
import OEObjectModelValueEdit from '../../../elements/object-model-value-edit/oe-object-model-value-edit';
import {OEAssetSelectionType} from '../../asset-selection/oe-asset-selection-model';
import {OEAssetSelectionPopover} from '../../asset-selection/oe-asset-selection-controller';
import {OEFunctionFragmentType, OEFunctionFragmentIcons, OEFunctionFragmentParameterModel} from './oe-function-model';

export default class OEFunctionFragmentCell extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.uid = oeUniqueIdGen.get();
        this.popoverTargetId = 'function-fragment-cell-popover-target-id-' + this.uid;

        this.state = {
            parameterModel: OEFunctionFragmentParameterModel.modelForType(this.props.type),
            showMediaAssetSelectionView: false
        };

        this.onDumpBtnPressed = this.onDumpBtnPressed.bind(this);
        this.onParameterChange = this.onParameterChange.bind(this);
        this.onMediaBtnPressed = this.onMediaBtnPressed.bind(this);
        this.onMediaAssetSelectionViewToggle = this.onMediaAssetSelectionViewToggle.bind(this);
        this.onMediaAssetSelectionViewOkBtnPressed = this.onMediaAssetSelectionViewOkBtnPressed.bind(this);
    }

    componentWillReceiveProps(nextProps)    {
        if(nextProps.type !== this.props.type)    {
            this.setState({parameterModel: OEFunctionFragmentParameterModel.modelForType(nextProps.type)});
        }

        if(nextProps.disabled !== this.props.disabled && nextProps.disabled)    {
            this.setState({showMediaAssetSelectionView: false});
        }
    }

    renderBar()  {
        let extraBtns = [];

        if(this.props.type === OEFunctionFragmentType.showMedia)    {
            extraBtns.push(
                <OEIconButton key={extraBtns.length} className="transparent-btn media-btn" disabled={this.props.disabled} icon={OEIconCodes.func.media} activated={this.state.showMediaAssetSelectionView} onPressed={this.onMediaBtnPressed}/>
            );
        }

        return (
            <div className="bar">
                <OEIcon className="function-fragment-type" code={OEFunctionFragmentIcons.iconForType(this.props.type)}/>
                <div className="buttons">
                    {extraBtns}
                    <OEIconButton className="transparent-btn dump-btn" disabled={this.props.disabled} icon={OEIconCodes.func.dumpFragment} onPressed={this.onDumpBtnPressed}/>
                </div>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <div className="function-fragment-cell" id={this.popoverTargetId}>
                    <div className="content">
                        {this.renderBar()}
                        <OEObjectModelValueEdit disabled={this.props.disabled} model={this.state.parameterModel} object={this.props.params} onChange={this.onParameterChange}/>
                    </div>

                    {this.props.showSeparator ? <div className="std-separator-border-color separator"/> : null}

                    {this.props.type !== OEFunctionFragmentType.showMedia ? null :
                        <OEAssetSelectionPopover
                            moduleId={this.props.moduleId}
                            className={this.props.popoverClassName}
                            boundariesElement={this.props.boundariesElement}
                            target={this.props.popoverTargetId ? this.props.popoverTargetId : this.popoverTargetId}
                            placement="right-start"
                            hideArrow={true}
                            isOpen={this.state.showMediaAssetSelectionView}
                            onToggle={this.onMediaAssetSelectionViewToggle}
                            backdrop={false}
                            types={[OEAssetSelectionType.image, OEAssetSelectionType.video, OEAssetSelectionType.web, OEAssetSelectionType.pdf]}
                            allowsMultipleSelection={false}
                            onOkBtnPressed={this.onMediaAssetSelectionViewOkBtnPressed}
                        />
                    }
                </div>

            </React.Fragment>
        );
    }

    onDumpBtnPressed()  {
        if(this.props.onDumpBtnPressed) this.props.onDumpBtnPressed(this, this.props.id);
    }

    onParameterChange(sender, params)   {
        if(this.props.onChange) this.props.onChange(this, this.props.id, params);
    }

    onMediaBtnPressed() {
        this.setState({showMediaAssetSelectionView: !this.state.showMediaAssetSelectionView});
    }

    onMediaAssetSelectionViewToggle(selection)   {
        this.setState({showMediaAssetSelectionView: false});
    }

    onMediaAssetSelectionViewOkBtnPressed(selection) {
        if(this.props.disabled)    return;

        this.setState({showMediaAssetSelectionView: false});

        let item = Array.isArray(selection) ? selection.at(0) : selection;
        if(!this.oe.isReady() || this.props.type !== OEFunctionFragmentType.showMedia || !item)  return;
        
        let mcItem = this.oe.sharedInterface.getUIControllerMediaCenter().getMediaItemDataID(item.ids.first);
        if(!mcItem) return;

        const MCItemType = this.oe.Module.MediaCenterItemType;

        let mediaType;
        if(mcItem.type === MCItemType.video)    {
            mediaType = OEMediaType.video;
        } else if(mcItem.type === MCItemType.image)    {
            mediaType = OEMediaType.image;
        } else if(mcItem.type === MCItemType.html)    {
            mediaType = OEMediaType.web;
        } else if(mcItem.type === MCItemType.pdf)    {
            mediaType = OEMediaType.pdf;
        }

        if(!mediaType)  return;

        let params = {
            mediaType: mediaType,
            path: '',
            pathId: mcItem.path,
            flags: this.props.params.flags
        };

        if(!OEToolbox.shallowEqual(params, this.props.params, true) && this.props.onChange) this.props.onChange(this, this.props.id, params);
    }
}

OEFunctionFragmentCell.defaultProps = {
    moduleId:                   '',
    showSeparator:              false,
    disabled:                   false,
    type:                       OEFunctionFragmentType.noOp,
    params:                     {}
};

OEFunctionFragmentCell.propTypes = {
    moduleId:                   PropTypes.string,
    popoverClassName:           PropTypes.string,
    showSeparator:              PropTypes.bool,
    disabled:                   PropTypes.bool,
    id:                         PropTypes.number,
    type:                       PropTypes.number,
    params:                     PropTypes.object,
    onChange:                   PropTypes.func,
    onDumpBtnPressed:           PropTypes.func
};